import script from "./ChatSupport.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatSupport.vue?vue&type=script&setup=true&lang=ts"

import "./ChatSupport.vue?vue&type=style&index=0&id=967fbd7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-967fbd7a"]])

export default __exports__